<template>
  <div>
<!-- Modal -->
    <div class="video-container">
      <div class="row no-gutters">
        <div class="col-md-8 sd-video-player" v-show="isPlayerVisible">
        <!-- 16:9 aspect ratio -->
        <div data-vjs-player>
            <div class="video-top-right">
          <a class="zoom-button" @click="zoomVideo" v-if='showZoomButton'>
            <img src="@/assets/img/zoom_icon.svg" class="img-fluid m-2 mr-3" width="18">
          </a>
          <a class="screenshot-button" @click="takeScreenshot(false)">
            <img src="@/assets/img/screenshot_icon.svg" class="img-fluid m-2 mr-3" width="18">
          </a>
          <a class="comments-button" @click="commentsClickHandler">
            <img src="@/assets/img/comments_icon_white.svg" class="img-fluid m-2 mr-3" width="18">
          </a>
          <a class="export-button" @click="exportClickHandler" v-if="isExportEnabled">
            <img src="@/assets/img/export_icon.svg" class="img-fluid m-2 mr-3" width="18">
          </a>
          <a class="close-button" @click="closePlayer">
            <!-- <span aria-hidden="true">&times;</span> -->
            <img src="@/assets/img/close_icon.svg" class="img-fluid m-2 mr-3" width="14">
          </a>
        </div>
          <video
            id="js-video-player"
            ref="player"
            class="video-js vjs-16-9"
            controls
            preload="auto"
            crossorigin="anonymous"
            @playing="updatePaused" @pause="updatePaused" @canplay="updatePaused"
            >
              <p class="vjs-no-js">
                To view this video please enable JavaScript, and upgrade to a web browser that
                supports HTML5 video
              </p>
            </video>

          <div v-if="exportVisible" class="sd-export-section">
            <form v-if="!exportInProgress" class="form-inline p-2" v-on:submit.prevent="triggerExport">
              <p v-if="exportError" class="sd-font-sm text-primary font-weight-bold">{{exportError}}</p>
              <vue-slider v-model="exportValue" ref="exportSlider" v-bind="exportSliderOptions"></vue-slider>
              <label class="sd-font-sm text-dark" v-if="secondsBasedExport">  Seconds</label>
              <label class="sd-font-sm text-dark" v-else>  Chainage</label>
              <button type="submit" class="btn btn-primary btn-sm export-button ml-2">Export</button>
            </form>
            <p v-if="exportInProgress" class="p-2 mb-0 text-dark">
              Export is in progress. Please don't refresh the page.
             <br>This may take few minutes. Please be patient.
            </p>
          </div>
        <div class="col-md-4 px-3 py-4 sd-comments-section" v-if="isCommentsTabVisible">
          <a class="sd-comments-close" @click="commentsClickHandler">
            <span aria-hidden="true">&times;</span>
          </a>
          <commentCreate
            @commentCreateSuccess='closeCommentBox()'
            :subsectionDataId='videoData.data_id'
            :latlng='latlng'
            :commentImage='commentImg'
            :commentSeconds='$refs.player.currentTime'
            :videoTime='$refs.player.currentTime'
            :isChainageEnabled='isChainageEnabled'
            :commentChainage='commentChainage'>            
          </commentCreate>
        </div>
        </div>
        </div>
      </div>
      </div>
      <!-- Successful Comment Message -->
      <div v-if="commentSuccess">
        <displayGlobalMessage v-if="commentSuccess" :message='"Issue Successfully Created"'></displayGlobalMessage>
      </div> 
      <!-- Zoom Viewer -->
      <div style='display: none'>
        <div ref='zoomViewer'>
          <img :src=zoomedFrame>
        </div>
      </div>
</div>

    <!-- Video Popup End -->
</template>

<script>
import Viewer from 'viewerjs';
import videojs from 'video.js';
import vueSlider from 'vue-slider-component';
import commentCreate from '@/components/commentCreate.vue';
import displayGlobalMessage from '@/components/displayGlobalMessage.vue';

import { mapActions, mapMutations, mapState } from 'vuex';

import api from '@/api';
import { API_ROOT, POSITION_TIME_DATA_SETTERS } from '@/config';
import {
  getClosestIndexFromChainage,
  getClosestIndexFromTime,
  getClosestIndexFromLatLng,
} from '@/utils/posDataOperations';

export default {
  // TODO: Validate and Require sid
  components: {
    vueSlider,
    commentCreate,
    displayGlobalMessage,
  },
  props: ['sid', 'did'],
  data() {
    return {
      commentChainage:0,      
      exportValue: [
        0,
        0,
      ],
      exportSliderOptions: {
        tooltipDir: 'bottom',
        width: '80%',
        min: 0,
        max: 0,
        interval: 0.1,
        processStyle: {
          backgroundColor: '#4a90e2',
        },
        tooltipStyle: {
          backgroundColor: '#4a90e2',
          borderColor: '#4a90e2',
        },
      },
      showZoomButton: true,
      isExportEnabled: false,
      secondsBasedExport: false,
      exportInProgress: false,
      exportVisible: false,
      exportError: '',
      projectName: '',
      videoElement: null,
      paused: null,
      isPlayerVisible: false,
      isCommentsTabVisible: false,
      videoData: '',
      videojsPlayer: '',
      viewer: '',
      zoomedFrame: '',
      commentSuccess: false,
      comment: {
        commentText: '',
        commentTime: 0,
        commentChainage: 0,
        videoDataId: 0,
      },
      // TODO: Add this to feature flags?
      autoplayNext: true,
      commentImg:{},
      latlng: {},
      isChainageEnabled: false,      
      droneAltitudeEl: '',
    };
  },
  mounted() {
    this.videojsPlayer = videojs('js-video-player', {});
    this.videojsPlayer.on('fullscreenchange', (e) => {
      this.showZoomButton = !this.videojsPlayer.isFullscreen();
    })
    this.videojsPlayer.on('loadeddata', (e)=> {
      if (this.isPlayerVisible) {
        this.updatePlayertime();
        this.play();
      }
    });
    this.setVideoWatcher();
    this.$root.$on('playvideo', () => {
      this.play();
      this.isPlayerVisible = true;
      this.showAltitude();
    });
    this.$root.$on('pausevideo', () => {
      this.pause();
    });
    this.viewer = new Viewer(this.$refs.zoomViewer);
    this.initData();
  },
  destroyed() {
    if (this.videojsPlayer) {
      this.videojsPlayer.dispose();
    }
  },
  computed: {
    ...mapState([
      'currentProject',
      'currentSubsection',
      'globalPosData',
      'positionTimeData',
      'commentsData',
      'isVideoPlayerVisible',
    ]),
  },
  watch: {
    currentProject() {
      this.projectName = this.currentProject.name;
      Array.from(this.currentProject.project_features).forEach((feat) => {
        if ( feat.feature_name == 'chainageProject' && feat.enabled ) {
          this.isChainageEnabled = true;
        }
        if ( feat.feature_name == 'exportVideoFeature' && feat.enabled ) {
          this.isExportEnabled = true;
        }
      });
      this.initData();      
    },
    globalPosData() {
      if (this.globalPosData.setter !== POSITION_TIME_DATA_SETTERS.VIDEO) {
        this.updatePlayertime();
      }
    },
    commentsData() {
      // Add Comments to videoJS
    },
    positionTimeData() {
      const lastchainage = this.positionTimeData[this.positionTimeData.length - 1].chainage;
      const lastSecond = this.positionTimeData[this.positionTimeData.length - 1].seconds;
      if(lastchainage) {
        this.exportSliderOptions.max = lastchainage;
      } else {
        this.secondsBasedExport = true;
        this.exportSliderOptions.max = lastSecond;
      }
      
    },
    did() {
      this.initData();
      this.showAltitude();
    },
    isPlayerVisible() {
      this.setVideoPlayerVisibility(this.isPlayerVisible);
    },
    isVideoPlayerVisible() {
      this.isPlayerVisible = this.isVideoPlayerVisible;
    }
  },
  methods: {
    ...mapMutations([
      'setGlobalPosData',
      'setVideoPlayerVisibility',
    ]),
    ...mapActions([
      'playNextVideo',
    ]),
    showAltitude() {   
     let subsections = this.currentProject.subsections[0].data;           
     for(let subsection in subsections) {      
       if (subsections[subsection].type === 'video' && subsections[subsection].layer.length > 0 && subsections[subsection].data_id === this.did) {                      
        if (!this.droneAltitudeEl) {          
          this.droneAltitudeEl = videojs.dom.createEl('div', {
            className: 'vjs-showaltitude-div',
            innerHTML: `<span className='vjs-showaltitude-text'>Drone Altitude: ${subsections[subsection].layer[0]}</span>`,
          });
          this.videojsPlayer.el().appendChild(this.droneAltitudeEl);         
        } else {                  
          this.droneAltitudeEl.innerHTML = `<span className='vjs-showaltitude-text'>Drone Altitude: ${subsections[subsection].layer[0]}</span>`;
        }
       }
     }     
    },
    initData() {
      this.getSubsectionData();
    },
    getSubsectionData() {
      if (!this.currentProject.subsections) { return; }
      Array.from(this.currentSubsection.data).forEach((data) => {
        if (Number(data.data_id) == Number(this.did)) {
          this.videoData = data;
        }
      })
      this.loadVideoSource();
    },
    loadVideoSource() {
      this.videojsPlayer.src({
        type: 'video/mp4',
        src: this.videoData.video,
      });
    },
    setVideoWatcher() {
      this.videojsPlayer.on('timeupdate',(e) =>{
          this.updatePosDataFromVideo();
      })
    },

    play() {
      this.videojsPlayer.play();
    },

    pause() {
      this.videojsPlayer.pause();
    },

    updatePlayertime() {
      const latlng = L.latLng(
        this.globalPosData.lat,
        this.globalPosData.lng,
      );

      const closestIndex = getClosestIndexFromLatLng(latlng, this.positionTimeData, L);
      const globalTime = this.positionTimeData[closestIndex].seconds;

      if(Math.abs(this.$refs.player.currentTime - globalTime) > 3) {
        this.$refs.player.currentTime = globalTime;
      }
    },

    updatePaused(event) {
      this.videoElement = event.target;
      this.paused = event.target.paused;
    },

    updatePosDataFromVideo() {
      if (this.autoplayNext && this.videojsPlayer.ended()) {
        this.playNextVideo(this.did);
      }
      if (this.$refs.player.currentTime == 0 &&
          this.globalPosData.setter != POSITION_TIME_DATA_SETTERS.VIDEO) {
        // If the video has been changed by something other than autoplay, or
        // new video state, then we want to maintain the existing globalPosData
        // so that the video can scrub to that point.
        // FIXME: See where this might break. Check if the conditional checker
        // can break in any circumstance
        return;
      }
      const posData = {
        lat: 0,
        lng: 0,
        setter: '',
      };

      const closestIndex = getClosestIndexFromTime(this.$refs.player.currentTime, this.positionTimeData);
      if ( this.isChainageEnabled ) {
        this.commentChainage = this.positionTimeData[closestIndex].chainage;
      }
      if (closestIndex !== -1) {
        posData.lat = this.positionTimeData[closestIndex].lat;
        posData.lng = this.positionTimeData[closestIndex].lng;
        posData.setter = POSITION_TIME_DATA_SETTERS.VIDEO;
        this.setGlobalPosData(posData);
      } else {
        // console.log('error');
      }
    },

    triggerExport() {
      const exportValues = this.$refs.exportSlider.getValue();

      if (!this.secondsBasedExport && (exportValues[1] - exportValues[0] > 7)) {
        this.exportError = 'Export Feature currently supports chainage range of 7. Please select smaller chainage range';
        return;
      } else if (exportValues[1] - exportValues[0] > 780) {
        this.exportError = 'Export Feature currently supports a duration of 13mins only. Please select smaller video duration';
        return;
      }

      this.exportError = '';
      let startIndex = '';
      let endIndex = '';
      let startSec = '';
      let endSec = '';
      if(!this.secondsBasedExport) {
        startIndex = getClosestIndexFromChainage(exportValues[0], this.positionTimeData);
        endIndex = getClosestIndexFromChainage(exportValues[1], this.positionTimeData);
        startSec = Math.floor(this.positionTimeData[startIndex].seconds);
        endSec = Math.floor(this.positionTimeData[endIndex].seconds);
      } else {
        startSec = Math.floor(exportValues[0]);
        endSec = Math.floor(exportValues[1]);
      }


      api.exportVideo(this.did, startSec, endSec)
        .then((response) => {
          if (response.status === 200) {
            this.exportInProgress = true;
            this.pollVideoExport(response.data.download_id);
            // this.pollVExport('d24076eb-f4a3-4db0-8fcc-80ede8c77b2c');
          } else {
            // console.log('error', response);
            // TODO: Handle Error
          }
        });
    },
    // TODO: Donot Allow Refresh
    // TODO: Add Timeout
    pollVideoExport(download_id) {
      api.pollExport(download_id)
        .then((res) => {
          if (res.status === 201) {
            window.location.href = `${API_ROOT}api/download/?download_id=${download_id}`;
            this.exportInProgress = false;
          } else if (res.status === 202) {
            setTimeout(this.pollVideoExport, 3000, download_id);
          }
        })
        .catch(() => {
          // console.log(err);
          // TODO: Handle error
          return false;
        });
    },

    // TODO: Use vue mixins to minimize code repeatition. Duplicate code on nav.vue

    // Video Related Functions End
    closePlayer() {
      this.pause();
      this.isPlayerVisible = false;
      if(this.isCommentsTabVisible) {
        this.isCommentsTabVisible = false;
      }
      if( this.droneAltitudeEl ) {            
        this.videojsPlayer.el().removeChild(this.droneAltitudeEl);            
        this.droneAltitudeEl= '';
      }
    },
    commentsClickHandler() {
      this.isCommentsTabVisible = !this.isCommentsTabVisible;
      if (this.isCommentsTabVisible) {
        // this.comment.commentTime = this.$refs.player.currentTime;
        this.takeScreenshot(true);
        this.pause();
        const closestIndex = getClosestIndexFromTime(this.$refs.player.currentTime, this.positionTimeData);
        if ( this.isChainageEnabled ) {  
          this.commentChainage = this.positionTimeData[closestIndex].chainage;
        }
        this.latlng.lat = this.positionTimeData[closestIndex].lat;
        this.latlng.lng = this.positionTimeData[closestIndex].lng;
      } else {
        this.play();
      }
    },

    closeCommentBox() {
      this.commentSuccess = true;
      this.isCommentsTabVisible = !this.isCommentsTabVisible;
      this.play();

      setTimeout(() => {
        this.commentSuccess = false;
      }, 3000);
    },

    exportClickHandler() {
      const chainageDiff = 2;
      const secondDiff = 30;

      this.exportVisible = !this.exportVisible;

      if (this.exportVisible) {
        const index = getClosestIndexFromTime(this.$refs.player.currentTime, this.positionTimeData);
        const currentChainage = this.positionTimeData[index].chainage;
        const currentSecond = this.positionTimeData[index].seconds;
        if(!this.secondsBasedExport) {
          const exportLow = (currentChainage - chainageDiff > 0) ? (currentChainage - chainageDiff) : 0;
          const exportHigh = (currentChainage + chainageDiff < this.exportSliderOptions.max) ? (currentChainage + chainageDiff) : this.exportSliderOptions.max;
          this.exportValue = [exportLow.toFixed(1), exportHigh.toFixed(1)];
          this.pause();
        } else {
          const exportLow = (currentSecond - secondDiff > 0) ? (currentSecond - secondDiff) : 0;
          const exportHigh = (currentSecond + secondDiff < this.exportSliderOptions.max) ? (currentSecond + secondDiff) : this.exportSliderOptions.max;
          this.exportValue = [exportLow.toFixed(1), exportHigh.toFixed(1)];
        }
      } else {
        this.play();
      }
    },

    takeScreenshot(setVariable) {
      // Take a screenshot of the current frame of the video.
      // Note that this requires CORS enabled on the video source.
      this.pause();
      // const closestIndex = getClosestIndexFromTime(this.$refs.player.currentTime, this.positionTimeData);

      // const { chainage } = this.positionTimeData[closestIndex];
      const vid = this.$refs.player;
      const canvas = document.createElement('canvas');
      canvas.height = 1080;
      canvas.width = 1920;
      const context = canvas.getContext('2d');
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.font = '30px Roboto';
      context.fillStyle = 'white';
      context.shadowColor = '#000000';
      context.shadowBlur = 10;
      context.strokeStyle = 'black';
      context.lineWidth = 8;
      context.drawImage(vid, 0, 0, 1920, 1080);
      if ( this.isChainageEnabled ) {
        context.strokeText(`${this.projectName} : ${this.commentChainage}`, canvas.width/2 - 150, 980);
        context.fillText(`${this.projectName} : ${this.commentChainage}`, canvas.width/2 - 150, 980);
      }
      if(setVariable) {
        canvas.toBlob((blob)=>{
          this.commentImg = blob;
        });
      } else {
        const link = document.createElement('a');
        canvas.toBlob((blob) => {
          // We need to convert to blob, because direct conversion
          // to url creates a long url that chrome cannot download
          const url = URL.createObjectURL(blob);
          link.href = url;
          if ( this.isChainageEnabled ) {
            link.download = `Screenshot_${this.projectName}: ${this.commentChainage}.png`;
          } else {
            link.download = `Screenshot: ${this.projectName}.png`;
          }
          link.click();
        });
        this.play();
      }
    },

    zoomVideo() {
      this.pause();
      const vid = this.$refs.player;
      const canvas = document.createElement('canvas');
      canvas.height = 1080;
      canvas.width = 1920;
      const context = canvas.getContext('2d');
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(vid, 0, 0, 1920, 1080);
      canvas.toBlob((blob) => {
        // We need to convert to blob, because direct conversion
        // to url creates a long url that chrome cannot download
        const url = URL.createObjectURL(blob);
        this.zoomedFrame = url;
        this.viewer.show();
      });
    },
  },
};
</script>


<style lang="scss">
@import "../../node_modules/video.js/dist/video-js.min.css";
@import '../../node_modules/viewerjs/dist/viewer.css';

.video-container {
  position: absolute;
  top: 5rem;
  left: 5rem;
  width: 75vw;
  height: auto;
  // border: solid 1px #ffffff;
}

.sd-video-player {
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.5);
  z-index: 2;
  //position: relative;
}

// .sd-video-player:before {
//   content: '';
//   position: absolute;
//   background: linear-gradient(rgba(#000, .5),rgba(#000, 0));
//   top: 0;
//   right: 0;
//   bottom: 91%;
//   left: 0;
//   z-index: 2;
// }

.video-top-right {
  position:absolute;
  right: 0;
  top:0;
  z-index:3;
  background: linear-gradient(rgba(#000, .5),rgba(#000, .5));
  // .close {
  //   font-size:2rem;
  //   font-weight: normal;
  //   color:#fff;
  //   opacity:1;
  // }

  .close-button, .comments-button, .export-button{
    cursor: pointer;
  }
  .screenshot-button {
    cursor: pointer;
  }
  .zoom-button {
    cursor: pointer;
  }
}
.sd-export-section {
  background-color: #fff;
  z-index: 3;
  .export-button {
    font-size: 0.8rem;
  }
}

// .player-overlay {
//   background-image: linear-gradient(rgba(#fff, 1),rgba(#fff, 1)),
//                     url("../../assets/img/bg_map.svg");
//   background-size: cover;
//   background-position: top;
//   z-index: 50000000;
// }

.sd-comments-section {
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.5);
  background-color: #fff;
  color:black;
  font-size:13px;
  border-radius: 0.3rem;
  z-index:5;
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  .sd-comments-close {
    position:absolute;
    right: 1rem;
    top:.2rem;
    font-size:1.5rem;
    color:#fff;
    cursor: pointer;
    opacity:1;
  }
}

// Work Around: this is to overwrite '.videojs button' class 
.sd-export-section .btn-primary {
  color: #fff !important;
  background-color: #f06031 !important;
  border-color: #f06031 !important;
}

.vjs-showaltitude-div{
border-radius: 5%;
height: 1.6rem;
padding: 0.5rem;
background-color:#141516;;
position: absolute;
bottom: 13%;
left: 7%;
opacity: 0.8;
}


</style>
